import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usage-terms-content',
  templateUrl: './usage-terms-content.component.html',
  styleUrls: ['./usage-terms-content.component.css'],
})
export class UsageTermsContentComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
